import { useEffect, useRef } from 'react';

type UseMouseCoordinatesHookMethod = () => UseMouseCoordinatesHook;

export type UseMouseCoordinatesHook = {
	getXY: () => { x: number, y: number }
};

export const useMouseCoordinates : UseMouseCoordinatesHookMethod = () => {
	
	const coordinates = useRef<{ x: number, y: number }>( { x: 0, y: 0 } );
	
	const handleMouseMove = ( e: MouseEvent ) => {
		
		coordinates.current = { x: e.x, y: e.y };
		
	};
	
	// Add event listeners
	useEffect( () => {
		window.addEventListener( 'mouseenter', handleMouseMove );
		window.addEventListener( 'mousemove', handleMouseMove );
		
		// Remove event listeners on cleanup
		return () => {
			window.removeEventListener( 'mouseenter', handleMouseMove );
			window.removeEventListener( 'mousemove', handleMouseMove );
		};
		
	}, [] ); // Empty array ensures that effect is only run on mount and unmount
	
	return {
		getXY: () => coordinates.current
	}
};

